import SheetBoardImgSrc from 'assets/images/sheet.png'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

const DocumentsSignHeader = () => {
  const { t } = useTranslation()

  return (
    <div tw='flex gap-2 md:gap-6'>
      <div>
        <Heading variant='subtitle'>{t('flow-doc-sign')}</Heading>
        <Typography text variant='subbody' twStyle={tw`mt-2 text-grey-dark tracking-[-0.15px]`}>
          {t('flow-doc-sign-rule')}
        </Typography>
        <hr tw='my-5 border-grey-middle' />
      </div>
      <img src={SheetBoardImgSrc} alt='sheet-board-img' tw='w-[54px] md:w-24 h-[54px] md:h-24' />
    </div>
  )
}

export default DocumentsSignHeader
